import { useGetEntities } from '@abaninja/util-store';

import { getDocumentComments } from '../documents';

export const useDocumentCommentsStore = () => useGetEntities(getDocumentComments);
